export function tanquesvirtuaisInRequest(params = {}) {
  return {
    type: '@tanquesvirtual/TANQUESVIRTUAIS_IN_REQUEST',
    payload: { params },
  };
}

export function findTanquesVirtual(idtanquevirtual) {
  return {
    type: '@tanquesvirtual/FIND_TANQUESVIRTUAL',
    payload: { idtanquevirtual },
  };
}

export function failedRequest() {
  return {
    type: '@tanquesvirtual/FAILED_REQUEST',
  };
}

export function deleteTanquesVirtual(idtanquevirtual, params) {
  return {
    type: '@tanquesvirtual/DELETE_TANQUESVIRTUAL',
    payload: { idtanquevirtual, params },
  };
}

export function updateTanquesVirtual(tanquesvirtual, params) {
  return {
    type: '@tanquesvirtual/UPDATE_TANQUESVIRTUAL',
    payload: { tanquesvirtual, params },
  };
}

export function storeTanquesVirtual(tanquesvirtual, params) {
  return {
    type: '@tanquesvirtual/STORE_TANQUESVIRTUAL',
    payload: { tanquesvirtual, params },
  };
}

export function successInRequest(
  tanquesvirtuais,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@tanquesvirtual/SUCCESS_IN_REQUEST',
    payload: { tanquesvirtuais, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(tanquesvirtual) {
  return {
    type: '@tanquesvirtual/SUCCESS_REQUEST',
    payload: { tanquesvirtual },
  };
}

export function successRemove(params) {
  return {
    type: '@tanquesvirtual/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@tanquesvirtual/RECORD_FILTERING',
    payload: { params },
  };
}
